<!-- 车辆及车牌图片补录接口内容 -->
<template>
  <div class="">
    <right-structure :Pdatas='infoData'>
      <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
      <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
    </right-structure>
  </div>
</template>

<script>
  import structure from "@/components/commonStructure"

  export default {
    name: '',
    components: {
      'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
      return {
        requestBody: {
	"parkCode": "2KNTYVWC",
	"pictureFile": "iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAIAAADYYG7QAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAD6SURBVFhH7ZZRDsIwDEN3Wu5/g4FUEUVNmZ0mEkN4X0Ba9fXFaznOmz3HzXhOAaGOyJAMIQOorgz9haHH+3nt1n9Gm6fqiQzZ2hGokQwDLTlss6M6vrbYwkBetF/eQyz5qA6FQc1AexB+Vj9QsXEYKGYI/lLxhIFSGaqgjLnNQDH1WcR9oKlx33ztlyd1McsmkjXkfUxduChl+4UzNC22jEiXGzbU8XL4ZGjDR5zCtmx5Ufgg241WxCoBmbypa5WXfxMo5ub6TwGvjQVi1mPGQDIWiD/3iqdAAghurmWAgJBGGZIhZADVlSEZQgZQXRmSIWQA1ZWhnzP0BG0XxAI+PzZQAAAAAElFTkSuQmCC",
	"platePictureFile": "iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAIAAADYYG7QAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAD6SURBVFhH7ZZRDsIwDEN3Wu5/g4FUEUVNmZ0mEkN4X0Ba9fXFaznOmz3HzXhOAaGOyJAMIQOorgz9haHH+3nt1n9Gm6fqiQzZ2hGokQwDLTlss6M6vrbYwkBetF/eQyz5qA6FQc1AexB+Vj9QsXEYKGYI/lLxhIFSGaqgjLnNQDH1WcR9oKlx33ztlyd1McsmkjXkfUxduChl+4UzNC22jEiXGzbU8XL4ZGjDR5zCtmx5Ufgg241WxCoBmbypa5WXfxMo5ub6TwGvjQVi1mPGQDIWiD/3iqdAAghurmWAgJBGGZIhZADVlSEZQgZQXRmSIWQA1ZWhnzP0BG0XxAI+PzZQAAAAAElFTkSuQmCC",
	"channelSeq": "001",
  "cameraSeq": "13",
	"type": "1",
	"carLicenseNumber": "粤Y12345",
  "pictureId": "6666",
  "operatorName": "wdl",
  "operateTime": "2018-10-12 10:00:00"
},
        responseCode: {
          "data": {
	"pictureTime": "20181011143242",
	"pictureName": "1_1_95_20181011143242_Y12345.jpg",
	"newPictureUrl": "/picpath/2018/10/11/00000000000/1/car/1_1_95_20181011143242_Y12345.jpg",
	"platePictureName": "1_1_95_20181011143242_Y12345_plate.jpg",
  "newPlatePictureUrl": "/picpath/2018/10/11/00000000000/1/plate/1_1_95_20181011143242_Y12345_plate.jpg",
  "cameraType":"1"
          }, "message": "业务成功", "resultCode": 0, "status": 1
        },
        infoData: {
          explain: "第三方接入系统请求智慧停车开放平台车辆及车牌图片补录接口",
          t_url: this.commonUrls.test+"supplyCarPic",
          p_url: this.commonUrls.prod+"supplyCarPic",
          precondition: "无",
          fitSystem: "VEMS传统停车场",
          pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
          Q_params: [{
            titleName: null,
            tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' },
              { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
            td: [
              { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
              { info1: 'pictureFile', info2: '是', info3: 'String', info4: '车辆图片（图像流文件的Base64编码）' },
              { info1: 'platePictureFile', info2: '是', info3: 'String', info4: '车牌图片（图像流文件的Base64编码）'},
              { info1: 'channelSeq', info2: '是', info3: 'Integer', info4: '通道编号' },
              { info1: 'cameraSeq', info2: '是', info3: 'Integer', info4: '摄像枪编号' },
              { info1: 'type', info2: '是', info3: 'Integer', info4: '进出场类型：1进场，2出场，3异常开闸'},
              { info1: 'carLicenseNumber', info2: '是', info3: 'String', info4: '车牌号' },
              { info1: 'plateColor', info2: '否', info3: 'Integer', info4: '车牌颜色：0其他，1蓝色，2黄色，3白色，4黑色，5绿色（默认为1）'},
              { info1: 'carType', info2: '否', info3: 'Integer', info4: '车牌类型：0 表示其它车型，1 表示小型车，2 表示大型车（默认为0）' },
              { info1: 'carColor', info2: '否', info3: 'Integer', info4: '车身颜色：0-其他色，1-白色，2-银色，3-灰色，4-黑色，'
                  + '5-红色，6-深蓝，7-蓝色，8-黄色，9-绿色，10-棕色，11-粉色，12-紫色（默认为0）'},
              { info1: 'carModel', info2: '否', info3: 'Integer', info4: '车型：0其他。其他类型待定（默认为0）'},
              { info1: 'pictureId', info2: '是', info3: 'String', info4: '第三方系统为图片生成的唯一编号（不超过20位的数字组成）'},
              { info1: 'operatorName', info2: '是', info3: 'String', info4: '操作人'},
              { info1: 'operateTime', info2: '是', info3: 'String', info4: '操作时间，yyyy-MM-dd HH:mm:ss'},
            ]
          }],
          R_params: [{
            titleName: null,
            tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' },
              { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
            td: [
              { info1: 'pictureName', info2: '是', info3: 'String', info4: '图片名称' },
              { info1: 'pictureTime', info2: '是', info3: 'String', info4: '图片时间' },
              { info1: 'newPictureUrl', info2: '是', info3: 'String', info4: '新图片路径' },
              { info1: 'platePictureName', info2: '是', info3: 'String', info4: '车牌图片名称' },
              { info1: 'newPlatePictureUrl', info2: '是', info3: 'String', info4: '新车牌图片路径' },
              { info1: 'cameraType', info2: '是', info3: 'String', info4: '摄像枪类型 0其他 1主枪，2辅枪 3环境枪' },
            ]
          }],
          codeStatus: [{
            titleName: null,
            tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
            td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
          }],
        }
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  // @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/parking/supplyCarPic.vue